import { useState, useEffect } from 'react';
import { DebouncedResize } from 'constants/events';
import { breakpoints } from 'style/config';

/**
 * Custom hook to detect if the current viewport is small mobile UI (smMax breakpoint)
 * @returns {boolean} isSMUI - true if viewport matches smMax breakpoint
 */
const useIsSMUI = () => {
    const [isSMUI, setIsSMUI] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            const matches = window?.matchMedia(breakpoints.smMax)?.matches;

            if (matches !== undefined) {
                setIsSMUI(matches);
            }
        };

        handleResize();
        window.addEventListener(DebouncedResize, handleResize);

        return () => {
            window.removeEventListener(DebouncedResize, handleResize);
        };
    }, []);

    return isSMUI;
};

export default useIsSMUI;
